import React from "react";
import { QuizData, TourData, question } from "../../../../Types";
import { UseDownloadAsset } from "../../../../api/calls/Queries";
import { useQueryClient } from "@tanstack/react-query";
import { getLanguageFile } from "../../../common/GetLanguageFile";

function QuizSpot(props: {
  hotspotData: number;
  tourData: TourData;
  setOpen: (bool: boolean) => void;
}) {
  const { hotspotData, tourData, setOpen } = props;
  const queryClient = useQueryClient();
  const quizData: QuizData | undefined = queryClient.getQueryData([
    "GetQuiz",
    tourData.assignedQuizID,
  ]);

  const currentQuestion: question | undefined = React.useMemo(() => {
    return quizData?.data?.find((one: any) => one.questionId === hotspotData);
  }, [hotspotData, quizData?.data]);

  const { data: imageBlob } = UseDownloadAsset(currentQuestion?.questionImgKey);

  const questionIndex = React.useMemo(() => {
    const quizdata = tourData.quizData?.data;

    let index = quizdata?.findIndex(
      (question) => question.questionId === currentQuestion?.questionId
    );

    return index ?? 0;
  }, [currentQuestion?.questionId, tourData.quizData?.data]);

  return (
    <div className="quiz-popup">
      <div className="number">{questionIndex + 1}</div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          id="close"
          style={{ color: "#222" }}
          onClick={() => setOpen(false)}
        >
          {getLanguageFile("generics.close")}
        </button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {imageBlob && (
          <img
            src={imageBlob}
            alt="immagine domanda"
            loading="lazy"
            style={{
              maxWidth: 600,
              maxHeight: 300,
            }}
          />
        )}
      </div>

      <div>{currentQuestion?.questionText}</div>

      <br />
      <div className="answers-wrapper">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "50% 50%",
            // gridAutoColumns: "50% 50%",
          }}
        >
          {currentQuestion?.answers
            ?.sort((a, b) => {
              return a.answerOrder - b.answerOrder;
            })
            .map((ans: any) => (
              <button
                id="quiz-answer"
                key={ans.answerId}
                style={{
                  fontStyle: ans.isCorrect ? "italic" : undefined,
                  background: ans.isCorrect ? "#84E1BC" : undefined,
                }}
              >
                {ans.answerText}
              </button>
            ))}
        </div>
      </div>
    </div>
  );
}

export default QuizSpot;
